(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-synister-daily-countdown]';
  const timeZone = 'America/Detroit';
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone,
    calendar: 'gregory',
    numberingSystem: 'latn',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23'
  });

  function getParts(instant) {
    const parts = {};
    formatter.formatToParts(new Date(instant)).forEach((part) => {
      if (part.type !== 'literal') parts[part.type] = Number(part.value);
    });
    return parts;
  }

  function shiftDate(date, days) {
    const shifted = new Date(Date.UTC(date.year, date.month - 1, date.day + days));
    return {
      year: shifted.getUTCFullYear(),
      month: shifted.getUTCMonth() + 1,
      day: shifted.getUTCDate()
    };
  }

  function toInstant(date) {
    const target = Date.UTC(date.year, date.month - 1, date.day, 3);
    let instant = target;
    for (let attempt = 0; attempt < 4; attempt += 1) {
      const parts = getParts(instant);
      const wallTime = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
      const correction = target - wallTime;
      if (correction === 0) return instant;
      instant += correction;
    }
    throw new Error('Unable to resolve the Eastern daily countdown boundary.');
  }

  function getWindow(now) {
    const today = getParts(now);
    const todayBoundary = toInstant(today);
    if (now < todayBoundary) {
      return { start: toInstant(shiftDate(today, -1)), end: todayBoundary };
    }
    return { start: todayBoundary, end: toInstant(shiftDate(today, 1)) };
  }

  const countdowns = new Map();
  let interval = null;
  let activeWindow = null;

  function update() {
    if (countdowns.size === 0) return;
    const now = Date.now();
    if (!activeWindow || now < activeWindow.start || now >= activeWindow.end) activeWindow = getWindow(now);
    const seconds = Math.max(0, Math.ceil((activeWindow.end - now) / 1000));
    const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
    const duration = activeWindow.end - activeWindow.start;
    const elapsed = Math.min(duration, Math.max(0, now - activeWindow.start));

    countdowns.forEach((state, root) => {
      if (!root.isConnected) {
        countdowns.delete(root);
        return;
      }
      state.units.forEach((unit, index) => {
        const value = values[index];
        const number = index === 0 ? String(value) : String(value).padStart(2, '0');
        if (unit.number.textContent !== number) unit.number.textContent = number;
        const label = value === 1 ? unit.label.dataset.singular : unit.label.dataset.plural;
        if (unit.label.textContent !== label) unit.label.textContent = label;
      });
      if (state.percent) state.percent.textContent = `${Math.floor(elapsed * 100 / duration)}%`;
      if (state.progress) {
        state.progress.max = duration;
        state.progress.value = elapsed;
      }
      state.timer.dataset.dailyEndsAt = new Date(activeWindow.end).toISOString();
      state.timer.classList.add('t4s-countdown-enabled');
      root.setAttribute('data-daily-ready', '');
    });
    if (countdowns.size === 0 && interval !== null) {
      clearInterval(interval);
      interval = null;
    }
  }

  function initialize(scope) {
    const roots = Array.from(scope.querySelectorAll(selector));
    if (scope.matches && scope.matches(selector)) roots.unshift(scope);
    roots.forEach((root) => {
      if (countdowns.has(root)) return;
      const timer = root.querySelector('[data-synister-daily-time]');
      const percent = root.querySelector('[data-synister-daily-percent]');
      const progress = root.querySelector('[data-synister-daily-progress]');
      if (!timer) return;
      const units = Array.from(timer.children).map((unit) => ({
        number: unit.querySelector('.t4s-cd-number'),
        label: unit.querySelector('.t4s-cd-text')
      }));
      if (units.length !== 4 || units.some((unit) => !unit.number || !unit.label)) return;
      countdowns.set(root, { timer, percent, progress, units });
    });
    update();
    if (countdowns.size > 0 && interval === null) interval = setInterval(update, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    countdowns.forEach((state, root) => {
      if (event.target.contains(root)) countdowns.delete(root);
    });
    if (countdowns.size === 0 && interval !== null) {
      clearInterval(interval);
      interval = null;
    }
  });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) update();
  });
  window.addEventListener('pageshow', update);
})();

  } catch(e) { console.error(e); }
})();
})();
